import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';
import { Datepicker } from 'views/anyguide/layout/uikit';
import moment from 'moment';

import './DateFilter.scss';

class DateFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDates: {},
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // Post-loading behavior
    if (!nextProps.loading && this.props.loading) {
      this.props.closeFilter('date');
    }

    // Update state with already applied filters
    if (
      nextProps.open !== this.props.open &&
      nextProps.appliedDates &&
      nextProps.appliedDates !== this.state.selectedDates
    ) {
      this.setState({ selectedDates: nextProps.appliedDates });
    }
  }

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    if (
      this.props.mobile &&
      (this.state.selectedDates.start !== nextState.selectedDates.start ||
        this.state.selectedDates.end !== nextState.selectedDates.end)
    ) {
      this.props.updateMobileFilters('date', nextState.selectedDates);
    }
  }

  updateSelectedWithApplied = () => {
    if (this.props.appliedDates)
      this.setState({ selectedDates: this.props.appliedDates });
  };

  filterButtonClicked = () => {
    if (this.props.open) {
      this.props.closeFilter('date');
    } else {
      this.props.openFilter('date');
    }
  };

  handleClickOutside = (_evt) => {
    if (this.props.open && !this.props.loading && !this.props.mobile) {
      this.props.closeFilter('date');
      this.clearFilter();
    }
  };

  applyDateFilter = () => {
    this.props.applyFilter('date', this.state.selectedDates);
  };

  // Resets selected dates back to defaults
  clearFilter = () => {
    this.setState({ selectedDates: {} });
  };

  // Clears and applies reset
  clearAndApply = () => {
    this.clearFilter();
    this.props.applyFilter('date', {});
  };

  startDateChanged = (date) => {
    this.setState((prevState) => {
      const selectedDates = { ...prevState.selectedDates };
      selectedDates.start = date;

      // Change endDate if necessary
      if (!selectedDates.end) {
        selectedDates.end = date;
      }

      return { selectedDates };
    });
  };

  endDateChanged = (date) => {
    this.setState((prevState) => {
      const selectedDates = { ...prevState.selectedDates };
      selectedDates.end = date;
      return { selectedDates };
    });
  };

  // Calendar range rules =====
  shouldDisableDateStart = (date) => {
    const { selectedDates } = this.state;
    const calendarDate = moment(date);
    const today = moment().startOf('day');

    // Disable any date >= selected endDate if defined
    if (selectedDates.end) {
      if (calendarDate > moment(selectedDates.end)) return true;
    }

    // Disable any date <= today
    if (calendarDate < today) return true;

    return false;
  };

  minStartDate = () => {
    return moment().format('YYYY-MM-DD');
  };

  maxStartDate = () => {
    const { end } = this.state.selectedDates;
    if (end) return moment(end).format('YYYY-MM-DD');
    return null;
  };

  minEndDate = () => {
    const { start } = this.state.selectedDates;
    if (start) return moment(start).format('YYYY-MM-DD');
    return null;
  };

  maxEndDate = () => {
    return moment().add('6', 'months').format('YYYY-MM-DD');
  };

  shouldDisableDateEnd = (date) => {
    const { selectedDates } = this.state;
    const calendarDate = moment(date);
    const today = moment().startOf('day');

    // Disable any date < selected startDate if defined
    if (selectedDates.start) {
      if (calendarDate < moment(selectedDates.start)) return true;
    }

    // Disable any date <= today
    if (calendarDate < today) return true;

    return false;
  };
  // =====

  filterLabel = () => {
    const { open } = this.props;

    let labelDates = null;
    if (open) {
      labelDates = this.state.selectedDates;
    } else {
      labelDates = this.props.appliedDates;
    }

    let startDate = null;
    let endDate = null;

    if (labelDates && labelDates.start)
      startDate = moment(labelDates.start).format('MMM D');
    if (labelDates && labelDates.end)
      endDate = moment(labelDates.end).format('MMM D');

    if (startDate && endDate) {
      if (startDate === endDate) return startDate;
      return `${startDate} - ${endDate}`;
    }
    if (startDate) {
      return `${startDate}`;
    }

    return 'Dates';
  };

  renderSelector = () => {
    return (
      <div className="selectorRow ignore-react-onclickoutside">
        <div className="date from">
          From
          <Datepicker
            dateFormat="MMM D, YYYY"
            defaultDateFormat="MMM DD YYYY"
            weekStartDay={this.props.calendarStartsMonday ? 1 : 0}
            value={this.state.selectedDates.start}
            onChange={this.startDateChanged}
            disableDayFn={this.shouldDisableDateStart}
            placeholder="Start"
            forceMobile={this.props.mobile}
            openOnClickInput
            min={this.props.mobile ? this.minStartDate() : null}
            max={this.props.mobile ? this.maxStartDate() : null}
          />
        </div>
        <div className="date to">
          To
          <Datepicker
            dateFormat="MMM D, YYYY"
            defaultDateFormat="MMM DD YYYY"
            weekStartDay={this.props.calendarStartsMonday ? 1 : 0}
            value={this.state.selectedDates.end}
            onChange={this.endDateChanged}
            disableDayFn={this.shouldDisableDateEnd}
            placeholder="End"
            forceMobile={this.props.mobile}
            openOnClickInput
            min={this.props.mobile ? this.minEndDate() : null}
            max={this.props.mobile ? this.maxEndDate() : null}
          />
        </div>
      </div>
    );
  };

  renderClearButton = () => {
    const { start, end } = this.state.selectedDates;

    if ((start && start.length > 0) || (end && end.length > 0)) {
      return (
        <div className="clearButton brand-color" onClick={this.clearAndApply}>
          Clear
        </div>
      );
    }
    return <div />;
  };

  renderMobile = () => {
    return (
      <div className="filterBody dateFilter mobile">
        <div className="heading">Dates Available</div>
        {this.renderSelector()}
      </div>
    );
  };

  render() {
    if (!this.props.enabled) return null;
    if (this.props.mobile) return this.renderMobile();

    return (
      <div className="filter">
        <div
          className={`filterButton brand-border
            ${this.props.open ? 'open brand-bg' : null}
            ${this.props.filterApplied ? 'filterApplied brand-bg' : null}`}
          onClick={this.filterButtonClicked}
        >
          {this.filterLabel()}
        </div>

        <div
          className={`filterPopover dateFilterPopover arrow-top ${
            this.props.open ? '' : 'hidden'
          }`}
        >
          <div className="filterBody dateFilter">
            {this.renderSelector()}
            <div className="filterActions brand-color">
              {this.renderClearButton()}
              <div
                className={`applyButton submitButton ui fluid button anygreen brand-bg ${
                  this.props.loading ? 'loading' : null
                }`}
                onClick={this.applyDateFilter}
              >
                Apply
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default onClickOutside(DateFilter);
